import { createAsyncThunk } from "@reduxjs/toolkit";
import {handleErrorResponse} from '../../apis'
import axios from 'axios';

export const getQcData = createAsyncThunk('getQcData', async (data, {rejectWithValue}) => {
  const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/india-supply/gate-entry/get-order/${data?.gate_entry_id}`
  try {
    const response = await axios.get(URL, data)
    return response
  } catch (error) {
    return handleErrorResponse(error, rejectWithValue)
  }
});

export const getGrn = createAsyncThunk('getGrn', async (data, {rejectWithValue}) => {
  const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/india-supply/grn/get-orders`
  try {
    const response = await axios.post(URL, data)
    return response
  } catch (error) {
    return handleErrorResponse(error, rejectWithValue)
  }
});

export const createGrn = createAsyncThunk('createGrn', async (data, {rejectWithValue}) => {
  const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/india-supply/grn/create`
  try {
    const response = await axios.post(URL, data)
    return response
  } catch (error) {
    return handleErrorResponse(error, rejectWithValue)
  }
});

export const getFabricLabels = createAsyncThunk(
  "getFabricLabels",
  async (data, { rejectWithValue }) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/india-supply/get-fabric-labels/grn`;
    try {
      const response = await axios.post(URL, data);
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `fabric_label.pdf`);
      document.body.appendChild(link);
      link.click();
      return response;
    } catch (error) {
      return handleErrorResponse(error, rejectWithValue);
    }
  }
);